export default __webpack_public_path__ + "static/media/times-circle-solid.8abbdc17.svg";